module.exports = __webpack_public_path__ + "static/media/lullascape-5.18a53671.jpg";